<template>
  <div class="font-specimen-element" :class="`font-${defaultFontFamily}`">
    <div class="font-specimen-element-details" :style="{ color: titleColour }">
      <p class="font-specimen-name small">{{ name }}</p>
      <div v-if="options && options.length > 0">
        <select
          class="font-specimen-element-dropdown small"
          :class="`specimen-background-${backgroundColour}`"
          :id="`font-weight-${id}`"
          @change="onChange"
          :style="{ color: titleColour}"
        >
          <option
            v-for="(option, index) in options"
            :key="`option_${index}`"
            :value="option.fontFamily"
            :selected="option.fontFamily === defaultFontFamily"
            :style="{background: backgroundColour}"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
    </div>
    <div class="font-specimen-element-text">
      <p
        :id="`sample-text-${id}`"
        :style="{ fontFamily: currentFontFamily, color: fontColour }"
      >
        {{ sampleText }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sampleText: String,
    weight: String,
    id: [String, Number],
    options: Array,
    name: String,
    titleColour: String,
    backgroundColour: String,
    fontColour: String,
    defaultFontFamily: String,
  },
  data() {
    return {
      textElement: null,
      currentFontFamily: this.defaultFontFamily || this.options?.[0]?.fontFamily || 'inherit',
    };
  },
  mounted() {
    this.textElement = document.getElementById(`sample-text-${this.id}`);
    if (this.textElement) {
      this.textElement.style.fontFamily = this.currentFontFamily;
    }
  },
  methods: {
    onChange(event) {
      const fontFamily = event.target.value;
      this.currentFontFamily = fontFamily;
      if (this.textElement) {
        this.textElement.style.fontFamily = fontFamily;
      }
    },
  },
};
</script>